export const ItemsProgramaAnualAdquisiciones = [
    {         
        "nombre" : "Programa Anual de Adquisiciones 2017",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2017.pdf"
    },
    {            
        "nombre" : "Programa Anual de Adquisiciones 2018",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2018.pdf"
    },
    {          
        "nombre" : "Programa Anual de Adquisiciones 2019",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2019.pdf"
    },
    {           
        "nombre" : "Programa Anual de Adquisiciones 2020",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2020.pdf"
    },
    {           
        "nombre" : "Programa Anual de Adquisiciones 2021",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2021.pdf"
    },
    {            
        "nombre" : "Acta de Instalación del Comité de Adquisiciones del DIF Hidalgo 2021",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/Acta_Instalacion_Comite_DIFHGO_2021.pdf"
    },
    {            
        "nombre" : "Programa Anual de Adquisiciones 2022",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2022.pdf"
    },
    {           
        "nombre" : "Programa Anual de Adquisiciones 2023",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2023.pdf"
    },
    {           
        "nombre" : "PAAAyS Inicial 2024 Estatal",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_INICIAL2024_ESTATAL.pdf"
    },
    {           
        "nombre" : "PAAAyS Inicial 2024 Federal",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_INICIAL2024_FEDERAL.pdf"
    },
    {           
        "nombre" : "Programa Anual de Adquisiciones 2025",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2025.pdf"
    },
    {           
        "nombre" : "Acta de Comité Primera Sesión Ordinaria 2025",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/ACTA_COMITE_PRIMERA_SESION_ORDINARIA_2025.pdf"
    },
    {           
        "nombre" : "Programa Anual de Adquisiciones 2026",
        "linkPDF" : "https://dif.hidalgo.gob.mx/pdf/programa_anual_adquisiciones/PAAAyS_2026.pdf"
    }
]